import * as React from 'react'
import './table-row-entity-display.scss'

interface IEntityDisplayProps {
    title: string | React.ReactNode
    description?: React.ReactNode
    top?: React.ReactNode
    status?: React.ReactNode
    test?: React.ReactNode
    audience?: React.ReactNode
    badges?: React.ReactNode
}

export class TableRowEntityDisplay extends React.PureComponent<IEntityDisplayProps> {
    public static readonly baseClassName = 'sw-halo-ed'
    public static readonly leftContentClassName = 'sw-halo-ed-left'
    public static readonly rightContentClassName = 'sw-halo-ed-right'

    public render(): React.ReactNode {
        const showDescription = !!this.props.description || !!this.props.test
        const showBottom = !!this.props.badges || !!this.props.audience

        return (
            <div className="sw-halo-ed">
                <div className="sw-halo-ed-wrapper">
                    <div className="sw-halo-ed-top">
                        <div className="sw-halo-ed-top-wrapper">
                            <div className={TableRowEntityDisplay.leftContentClassName}>
                                <span className="sw-halo-ed-title">{this.props.title}</span>
                            </div>
                            <div className={TableRowEntityDisplay.rightContentClassName}>
                                <span className="sw-halo-ed-status">{this.props.status}</span>
                            </div>
                        </div>
                    </div>
                    {showDescription && (
                        <div className="sw-halo-ed-mid">
                            <div className="sw-halo-ed-mid-wrapper">
                                <div className={TableRowEntityDisplay.leftContentClassName}>
                                    <span className="sw-halo-ed-description">{this.props.description}</span>
                                </div>
                                <div className={TableRowEntityDisplay.rightContentClassName}>
                                    <span className="meta-wrapper">
                                        {!!this.props.test && (
                                            <span className="sw-halo-ed-meta">{this.props.test}</span>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {showBottom && (
                        <div className="sw-halo-ed-bottom">
                            <div className="sw-halo-ed-bottom-wrapper">
                                <div className={TableRowEntityDisplay.leftContentClassName}>
                                    <div className="sw-halo-ed-badges">{this.props.badges}</div>
                                </div>
                                <div className={TableRowEntityDisplay.rightContentClassName}>
                                    {!!this.props.audience && this.props.audience}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
